import { CircularProgress } from "@mui/material";
import styled from "styled-components";

export const Loader = () => {
  return (
    <Root>
      <CircularProgress color="secondary" />
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
